var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurantAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.80948C20.0003 6.90472 19.286 6.19043 18.3813 6.19043H10.286C9.38128 6.19043 8.66699 6.90472 8.66699 7.80948H20.0003Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 13.4761H18.7627V16.7142H20.0008V13.4761Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2391 11.8571H20.001V16.7142H21.2391V11.8571Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4295 10.238H21.1914V16.7142H22.4295V10.238Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8582 15.0951H23.6201V16.7141H24.8582V15.0951Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6199 15.0952V16.7142H22.3818V15.0952C22.3818 13.2856 23.8104 11.8571 25.6199 11.8571V13.0952C24.5247 13.0952 23.6199 13.9999 23.6199 15.0952Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5242 13.4761C17.5242 12.8094 17.0004 12.238 16.2861 12.238V10.9999C17.6195 10.9999 18.7147 12.0951 18.7147 13.4284V16.6665H17.4766L17.5242 13.4761Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4292 24.0474H17.5245L16.334 16.7141H25.6673L24.4292 24.0474Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6673 16.7141C23.0959 19.2855 18.9054 19.2855 16.334 16.7141C18.9054 19.2855 23.0959 19.2855 25.6673 16.7141Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14351 17.5237C1.71494 17.5237 1.33398 17.1428 1.33398 16.7142C1.33398 15.3809 2.42922 14.2856 3.76256 14.2856H10.2387C11.5721 14.2856 12.6673 15.3809 12.6673 16.7142C12.6673 17.1428 12.2864 17.5237 11.8578 17.5237H2.14351Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8578 20.3809C12.2864 20.3809 12.6673 19.9999 12.6673 19.5714C12.6673 19.1428 12.2864 18.7618 11.8578 18.7618H2.14351C1.71494 18.7618 1.33398 19.1428 1.33398 19.5714C1.33398 19.9999 1.71494 20.3809 2.14351 20.3809H11.8578Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 22.4285C12.6673 23.3333 11.953 24.0476 11.0483 24.0476H2.95303C2.04827 24.0476 1.33398 23.3333 1.33398 22.4285C1.33398 22 1.71494 21.619 2.14351 21.619H11.8578C12.334 21.619 12.6673 21.9524 12.6673 22.4285Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8578 20.3809H2.14355V21.619H11.8578V20.3809Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8578 17.5237H2.14355V18.7618H11.8578V17.5237Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7627 14.2856L4.57222 15.0952L3.7627 14.2856Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80952 15.5237L5 16.3332L5.80952 15.5237Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2383 15.5237L11.0478 16.3332L10.2383 15.5237Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00126 15.5237H6.8584H8.00126Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04785 14.2856V15.4285V14.2856Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9534 15.9047H2.81055H3.9534Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42871 7.80946L10.0954 14.2857H10.2382C11.5716 14.2857 12.6668 15.3809 12.6668 16.7142C12.6668 17.1428 12.2859 17.5237 11.8573 17.5237V18.7142C12.2859 18.7142 12.6668 19.0952 12.6668 19.5237C12.6668 19.9523 12.2859 20.3333 11.8573 20.3333V21.5714C12.2859 21.5714 12.6668 21.9523 12.6668 22.3809C12.6668 23.2857 11.9525 23.9999 11.0478 23.9999H17.5239L16.3335 16.7142H17.5239V13.4761C17.5239 12.8095 17.0001 12.238 16.2859 12.238V10.9999C17.3811 10.9999 18.3335 11.7618 18.6192 12.7618L19.143 7.76184H9.42871V7.80946Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95303 25.6667C2.04827 25.6667 1.33398 24.9524 1.33398 24.0476H25.6197C25.6197 24.9524 24.9054 25.6667 24.0006 25.6667H2.95303Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.1904L11.0476 2.33325C10.9524 2.14278 10.8571 1.9523 10.7143 1.80944C10.5714 1.66659 10.381 1.52373 10.1905 1.47611C10 1.38087 9.80952 1.33325 9.57143 1.33325H7H9.57143C9.80952 1.33325 10 1.38087 10.1905 1.47611C10.381 1.57135 10.5714 1.66659 10.7143 1.80944C10.8571 1.9523 11 2.14278 11.0476 2.33325L12.6667 6.1904Z",
    stroke: "#394553",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantAnalytics);
export default __webpack_public_path__ + "static/media/restaurant_analytics.b60a8a7d58ca15ac01b7bf650654b80c.svg";
export { ForwardRef as ReactComponent };